/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetAppointmentRequest} from '@cash-web/protos/squareup/cash/local/client/v1/local_appointment.pb'
import {GetAppointmentResponse} from '@cash-web/protos/squareup/cash/local/client/v1/local_appointment.pb'


export const getAppointment = (request: GetAppointmentRequest, options?: CashRequestOptions) => post<GetAppointmentRequest, GetAppointmentResponse>("/2.0/cash/get-appointment", request, {...options, rejectOnError: true })